import { render } from "./stock.list.no.examine.vue?vue&type=template&id=054f6bd5"
import script from "./stock.list.no.examine.vue?vue&type=script&lang=js"
export * from "./stock.list.no.examine.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__